module.exports = __webpack_public_path__ + "static/media/cash-flow-403-image.12fe88a3.png";